/* src/app/views/collection/components/modals/edit-collection-create-new-display/edit-collection-create-new-display.component.scss */
.edit-collection-create-new-display-container {
  padding-inline: 0.2rem;
}
/*# sourceMappingURL=edit-collection-create-new-display.component.css.map */
